"use client";
import React from 'react';
import Link from "next/link";
import Image from 'next/image';
import { Car } from '../models/Car';
import ImageContainer from './ImageContainer';
import { AiOutlineCheckCircle } from "react-icons/ai";
import { MdGpsFixed, MdOutlineLocalGasStation, MdAir, MdOutlineCarRental } from "react-icons/md";
import { FaCarSide, FaCalendarAlt, FaDoorOpen } from "react-icons/fa";
import { GiSteeringWheel } from "react-icons/gi";
import { BiSolidCar, BiUser } from "react-icons/bi";
import { BsFillBanFill } from "react-icons/bs";
import { PiEngineBold } from "react-icons/pi";
import { GiGearStickPattern } from "react-icons/gi";
import { BsSnow } from "react-icons/bs";
import { MdAirlineSeatReclineNormal } from "react-icons/md";
import { MdLocalGasStation } from "react-icons/md";

const iconStyle = "text-yellow-600 text-2xl mr-2";

const CarPageWrapper = ({ car }: { car: Car }) => {
    return (
        <div>
            <div className='mt-10' style={{ marginTop: '4.7rem', display: 'inline-block'}}></div>
            <div className="mt-9">
                <h2 className="text-xl font-bold flex items-center">
                    <span className="ml-3 text-[1.2rem] sm:text-[2rem] md:text-[2.5rem]" style={{ fontFamily: "inherit", letterSpacing: "1px" }}>
                        {car.name}
                    </span>
                </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                {/* Image */}
                <div>
                    <ImageContainer car={car} />
                </div>

                {/* Infos voiture */}
                <div className="pl-0 md:pl-9">
                    <p className="mt-3">{car.description}</p>

                    {/* Infos avec icônes */}
                    {/* <ul className="list-none pl-0 mt-3 space-y-3">
                        <li className="flex items-center"><FaCarSide className={iconStyle} /> {car.brand} {car.model}</li>
                        <li className="flex items-center"><FaCalendarAlt className={iconStyle} /> {car.year}</li>
                        <li className="flex items-center"><MdOutlineLocalGasStation className={iconStyle} /> {car.fuel}</li>
                        <li className="flex items-center"><PiEngineBold className={iconStyle} /> {car.transmission}</li>
                        <li className="flex items-center"><BiUser className={iconStyle} /> {car.seats} places</li>
                        <li className="flex items-center"><FaDoorOpen className={iconStyle} /> {car.doors} portes</li>
                        <li className="flex items-center"><BsFillBanFill className={iconStyle} /> Air conditionné : {car.airConditioning ? "Oui" : "Non"}</li>
                        <li className="flex items-center"><MdGpsFixed className={iconStyle} /> GPS : {car.gpsIncluded ? "Inclus" : "Non"}</li>
                        <li className="flex items-center"><MdOutlineCarRental className={iconStyle} /> Chauffeur : {car.hasDriver ? "Oui" : "Non"}</li>
                        <li className="flex items-center"><GiSteeringWheel className={iconStyle} /> Disponible à : {car.location}</li>
                    </ul> */}

                    {/* Prix */}
                    <div className="mt-4 text-xl font-bold">
                        <span className="text-3xl">{car.pricePerDay} MUR / jour</span>
                    </div>

                   
                    {/* Caractéristiques visuelles sous forme d'icônes */}
                    <div className="mt-6 w-full">
                        <div className="flex justify-between items-center border-t pt-4">
                            <div className="flex-1 text-center border-r last:border-r-0 px-2">
                                <div className="text-[2rem] flex justify-center mb-1" style={{ color: '#f8d340', fontSize: '28px'  }}>
                                    <GiGearStickPattern />
                                </div>
                                <span className="text-sm font-medium">{ car.transmission }</span>
                            </div>
                            <div className="flex-1 text-center border-r last:border-r-0 px-2">
                                <div className="text-[2rem] flex justify-center mb-1" style={{ color: '#f8d340', fontSize: '28px'  }}>
                                    <BsSnow />
                                </div>
                                <span className="text-sm font-medium">Aircon</span>
                            </div>
                            <div className="flex-1 text-center border-r last:border-r-0 px-2">
                                <div className="text-[2rem] flex justify-center mb-1" style={{ color: '#f8d340', fontSize: '28px'  }}>
                                    <MdAirlineSeatReclineNormal />
                                </div>
                                <span className="text-sm font-medium">Airbags</span>
                            </div>
                            <div className="flex-1 text-center px-2">
                                <div className="text-[2rem] flex justify-center mb-1" style={{ color: '#f8d340', fontSize: '28px'  }}>
                                    <MdLocalGasStation />
                                </div>
                                <span className="text-sm font-medium"> {car.fuel} </span>
                            </div>
                        </div>
                    </div>
    


                    {/* Bouton réservation */}
                    <div className="mt-8">
                        <Link href={`/booking/car`} className="mt-4">
                            <button className="btn-xl">
                                Réserver maintenant 
                            </button>
                        </Link>
                    </div>

                    {/* Visuels paiement */}
               

                     {/* Message disponibilité */}
                     <div className="mt-4 font-bold  px-3 py-2 rounded-md">
                        {car.available ? " Véhicule disponible immédiatement" : "⛔ Actuellement indisponible"}
                    </div>


                    <p className="pt-4 italic">
                        Utilisez les flèches gauche et droite situées en haut pour parcourir les véhicules.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CarPageWrapper;
